<div class="container">
  <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center top-16 gap-3">
    <h4>Detalhes do Instituto Previdenciário</h4>
    
    <vivest-button variant="outline" size="md" (click)="download()">
      <vivest-icon slot="icon-right" name="download" source="feather"></vivest-icon>
      Extrato de Desligamento Previdenciário
    </vivest-button>
  </div>
  @if (exibicao(); as dados) {
    <p class="protocolo">Protocolo: {{ dados.protocolo }}</p>
  }
  <app-pdf-document
    class="top-64"
    [src]="pdfSrcTermo()"
    [textoInformativo]="textoVisualizado()"
    [textoAdicional]="'Termo de adesão'"
  ></app-pdf-document>

  <!-- <div class="d-flex justify-content-center align-items-center buttons top-64">
    <vivest-button variant="secondary" size="md" (click)="onSubmit()">
      Cancelar escolha de Instituto Online
    </vivest-button>
  </div>
</div>

<vivest-modal
  heading="Deseja cancelar a escolha do seu Instituto?"
  description="Essa ação não poderá ser desfeita"
  dismissible
  [hasIcon]="true"
  [open]="openModal()"
  (vivest-close)="closeModal()"
>
  <img slot="icon" src="assets/images/icons/Cancel.svg" alt="" />
  <vivest-button slot="actions" variant="outline" size="md" (click)="closeModal()">Não, voltar</vivest-button>
  <vivest-button slot="actions" variant="secondary" size="md" (click)="cancelar()">Sim, cancelar</vivest-button>
</vivest-modal> -->